import { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './Textarea.module.css';

const Textarea = forwardRef(function Textarea({ label, error, className, id, rows = 3, ...props }, ref) {
  return (
    <div className={clsx(styles.wrap, className)}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <textarea
        id={id}
        ref={ref}
        rows={rows}
        className={clsx(styles.textarea, error && styles.hasError)}
        {...props}
      />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
});

export default Textarea;
